export default __webpack_public_path__ + "static/media/location_resume.add982da.svg";